(function () {
  // Marcar el documento como listo (previene FOUC si JS falla)
  document.documentElement.classList.add('otuma-reveal-ready');

  // Secciones que ya tienen animaciones propias — no las tocamos
  var SKIP_PATTERNS = [
    'otuma-split-hero',
    'otuma-favoritos',
    'otuma-footer',
    'otuma-fv3',
    'otuma-header',
    'otuma-cart-drawer',
    'otuma-drawer',
    'marquee',
    'announcement',
    'shopify-section-header',
    'header-group'
  ];

  // Elementos que pueden animarse dentro de cada sección
  var ANIMATABLE = [
    'h1', 'h2', 'h3', 'h4',
    'p',
    'blockquote', 'q',
    '.button', 'button', 'a.button',
    'img', 'picture', 'video',
    // Horizon rich-text & block patterns
    '.rich-text__text',
    '.rich-text__heading',
    '[class*="__heading"]',
    '[class*="__description"]',
    '[class*="__subheading"]',
    '[class*="__text"]:not(section):not(.shopify-section)'
  ].join(', ');

  function shouldSkip(section) {
    if (section.hasAttribute('data-otuma-no-reveal')) return true;
    if (section.classList.contains('otuma-no-reveal')) return true;
    var cls = (section.className || '').toLowerCase();
    return SKIP_PATTERNS.some(function (p) {
      return cls.indexOf(p) !== -1;
    });
  }

  function prepareSection(section) {
    var elements = section.querySelectorAll(ANIMATABLE);
    if (elements.length === 0) return [];

    // Deduplicar: si un elemento está dentro de otro ya incluido, se omite
    var unique = [];
    Array.prototype.forEach.call(elements, function (el) {
      var hasAncestor = unique.some(function (a) { return a.contains(el); });
      if (!hasAncestor) unique.push(el);
    });

    var firstHeadingUsed = false;
    unique.forEach(function (el, i) {
      // Primer h1/h2/h3 → blur reveal
      if (!firstHeadingUsed && /^H[1-3]$/.test(el.tagName)) {
        el.classList.add('otuma-reveal-el--blur');
        firstHeadingUsed = true;
      } else {
        el.classList.add('otuma-reveal-el');
      }
      // Stagger de 90ms, cap a 900ms para evitar cadenas eternas
      var delay = Math.min(i * 0.09, 0.9);
      el.style.transitionDelay = delay + 's';
    });

    return unique;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var section = entry.target;
        var els = section.querySelectorAll('.otuma-reveal-el, .otuma-reveal-el--blur');
        Array.prototype.forEach.call(els, function (el) {
          el.classList.add('otuma-revealed');
        });
        observer.unobserve(section);
      }
    });
  }, {
    threshold: 0.12,
    rootMargin: '0px 0px -6% 0px'
  });

  function init() {
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      if (shouldSkip(section)) return;
      // Saltar secciones que contengan el cart drawer o menu overlay
      if (section.querySelector('.otuma-drawer, #otumaMenuOverlay, #otumaSearchModal')) return;
      var prepared = prepareSection(section);
      if (prepared.length > 0) observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();